<template>
    <div class="p_t">
        <TopHead title="新闻详情"></TopHead>
        <div class="header">
            <h2>凭借实力凡尔赛，回顾这一年奥运我们“错失”的十块铜牌</h2>
            <span>时间： 2019-04-30</span> <span>浏览 1018次 </span>
        </div>
        <div class="a_top">
            <div class="f_content" >内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容</div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            
        };
    },
    methods: {
        
    },
}
</script>
<style lang="scss" scoped>
    .a_top{
    
    padding: 12px 12px 20px;
  }
  .header{
      width: 350px;
      margin: 10px auto 0;
      padding-bottom: 11px;
      border-bottom: 1PX solid #e5e5e5;
      h2{
          font-size: 18px;
          margin-bottom: 14px;
      }
      span{
          color: #8c8c8c;
          font-size: 12px;
          display: inline-block;
          width: 125px;
      }
  }
</style>
